import { Component, Input, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { CommonFunctions } from '@shared/common-functions';
import { USER_ROLES } from '@shared/constant/shared.constant';

@Component({
  selector: 'app-revenue-display',
  templateUrl: './revenue-display.component.html',
  styleUrls: ['../common-dashboard/common-dashboard.component.scss'],
})
export class RevenueDisplayComponent implements OnInit{
  @Input() totalRevenue: number = 0;
  @Input() occupiedCount: number = 0;
  @Input() vacantCount: number = 0;
  @Input() maintenanceCount: number = 0;
  @Input() parkerCount: number = 0;
  @Input() groupBookingCount: number = 0;
  @Input() groupBookingSlotCounts: number = 0;
  @Input() oneTimeBookingCount: number = 0;
  @Input() parkingStatsOptions;
  @Input() parkingStatsData;
  @Input() totalBookings: number = 0;
  @Input() peakHoursStartTime: string;
  @Input() peakHoursEndTime: string;
  @Input() dateRangeData: any;
  @Input() selectedParkingLot: any;
  @Input() checkStartDate: any;
  @Input() checkEndDate: any;
  @Input() companyId: any;
  @Input() role: any;
  @Input() revenueWithTransactionFees: number = 0;
  @Input() revenueWithTaxAndFees: number = 0;
  roleRoute: string = '';
  userRole = USER_ROLES;

  constructor(private readonly router: Router) {}

  ngOnInit() {
    this.roleRoute = CommonFunctions.routeToBookingDetail(this.role);
  }

  revenueClick() {
    const url =
      this.role === this.userRole.SUPER_ADMIN
        ? `${this.roleRoute}/financial/${this.companyId}`
        : `${this.roleRoute}/financials`;

    const navigationState: any = {
      selectedCompany: this.companyId,
      selectedParkingLot: this.selectedParkingLot,
      dateRange: this.dateRangeData,
      isDashboard: true
    };

    navigationState.checkStartDate = this.checkStartDate;
    navigationState.checkEndDate = this.checkEndDate;

    const navigation: NavigationExtras = { state: navigationState };
    this.router.navigateByUrl(url, navigation);
  }

  dailyBookingsClick() {
    const url =
      this.role === this.userRole.SUPER_ADMIN
        ? `${this.roleRoute}/bookings/${this.companyId}?tab=0`
        : `${this.roleRoute}/bookings?tab=0`;

    const navigationState: any = {
      selectedParkingLot: this.selectedParkingLot,
      checkStartDate: this.checkStartDate,
      checkEndDate: this.checkEndDate,
      isDashboard: true
    };

    const navigation: NavigationExtras = { state: navigationState };
    this.router.navigateByUrl(url, navigation);
  }

  navigateToBookings(userValue: number) {
    const url =
      this.role === this.userRole.SUPER_ADMIN
        ? `${this.roleRoute}/bookings/${this.companyId}?tab=1`
        : `${this.roleRoute}/bookings?tab=1`;

    const navigationState: any = {
      selectedParkingLot: this.selectedParkingLot,
      checkStartDate: this.checkStartDate,
      checkEndDate: this.checkEndDate,
      userValue,
      isDashboard: true
    };

    const navigation: NavigationExtras = { state: navigationState };
    this.router.navigateByUrl(url, navigation);
  }

  groupUserBookingsClick() {
    this.navigateToBookings(4);
  }

  parkerBookingsClick() {
    this.navigateToBookings(0);
  }
}
